import clsx from 'clsx'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import type { ICON } from '@/src/general/enums/icons'

export type TChatMessageHeaderProps = {
  title: ReactNode
  icon?: ICON
  color: 'white' | 'default' | 'secondary'
}

export const ChatMessageHeader = ({ title, icon, color }: TChatMessageHeaderProps) => (
  <View className="flex-row items-center gap-2 opacity-60">
    {icon && (
      <Icon
        name={icon}
        size="xs"
        className={clsx({
          'text-white': color === 'white',
          'text-default-text-contrast-low': color === 'default',
          'text-secondary-text-contrast-low': color === 'secondary',
        })}
      />
    )}
    <Typography size="xs" bold contrast="low" colors={color} numberOfLines={1} className="text-ellipsis">
      {title}
    </Typography>
  </View>
)
